export default __webpack_public_path__ + "static/media/edit.5ea29472.svg";